import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

const ContaAReceberListar = lazy(
  () => import('../pages/conta-a-receber-listar'),
)

export default function Component() {
  return (
    <Routes>
      <Route path="contas-a-receber" element={<ContaAReceberListar />} />
      <Route index element={<Navigate to="contas-a-receber" replace />} />
      <Route path="*" element={<Navigate to="contas-a-receber" replace />} />
    </Routes>
  )
}
